import React, { MouseEvent, useCallback } from "react";

import AntAvatar from "antd/es/avatar";
import cn from "classnames";

import Email from "@mapmycustomers/shared/types/email/Email";
import User from "@mapmycustomers/shared/types/User";
import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";
import getInitials from "@mapmycustomers/shared/util/ui/getInitials";
import { Avatar } from "@mapmycustomers/ui";

import UserPreviewCard from "@app/component/UserPreviewCard";

import styles from "./EmailUser.module.scss";

interface EmailUserProps {
  className?: string;
  email: Email;
  user?: User;
}

const EmailUser: React.FC<EmailUserProps> = ({ className, email, user }) => {
  const handleClearClick = useCallback((e: MouseEvent<Element>) => {
    e.stopPropagation();
  }, []);

  const renderContent = useDynamicCallback(() => {
    if (user) {
      return (
        <UserPreviewCard userId={user.id}>
          <Avatar actionOnHover user={user} />
        </UserPreviewCard>
      );
    }

    const emailSender = email.from[0];
    const initials = getInitials({
      id: -1,
      fullName: emailSender.name ?? null,
      username: emailSender.email,
    });

    return <AntAvatar className={styles.avatarWithInitials}>{initials}</AntAvatar>;
  });

  return (
    <div className={cn(styles.cotainer, className)} onClick={handleClearClick}>
      {renderContent()}
    </div>
  );
};

export default EmailUser;
